<template>

<div>
    <v-app id="main-page">
    <router-view></router-view>
  </v-app>
</div>
</template>

<script>
import './assets/index.css';
export default {
  name: 'App',
  data () {
    return {
    //
    }
  }
}
</script>


<style scoped>

#main-page {
  background-color: #fff;
}

.card-expansion {
  box-shadow: unset !important;
  border: 1px solid #eaeaea !important;
}

@media screen and (max-width: 425px) {
  #pages {
    padding: 1.5em;
  }
}
  
</style>
